<template>
  <div class="news-article-item">
      <div class="news-img">
          <img v-if="item.url!=null" :src="item.url" :alt="truncatedTitle">
          <img v-else src="../../assets/NewsTestImg.png">
      </div>
      <div class="news-text">
          <div class="news-content">
              <p class="news-tag">{{ item.dateTime | moment($t("dateFormat"))}}</p>
              <h3> <router-link class="news-title-link" :to="{ name: 'news-content', params: { id: this.id} }">{{ item.title }}</router-link></h3>
              <!-- <p v-html="truncatedHtmlContent" class="news-content-p"></p> -->
          </div>
      </div>
      <div class="news-button-container">
          <router-link class="card-news-button" :to="{ name: 'news-content', params: { id: this.id} }">{{ $t("more")}}</router-link>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  props: ["id", "viewMode"],
  name: "AppHighlightedNewsCard",
  data() {
      return {
          item: null,
          htmlContent: ""
      }
  },
  methods: {
      ...mapActions(["fetchContentById"]),
      loadData() {
          this.fetchContentById(this.id).then((contentResposnse) => {
              // this.item = contentResposnse;
              this.item.title = contentResposnse.title;
              this.htmlContent = contentResposnse.content;
          });
      },
  },
  computed: {
      ...mapGetters(["getContentById", "getSelectedLanguage"]),
      truncatedHtmlContent() {
          const plainText = (this.htmlContent || '').replace(/<[^>]*>/g, '');
          return plainText.length > 50 ? plainText.substring(0, 50) + '...' : plainText;
      },
      truncatedTitle() {
          return this.item && this.item.title ? 
              (this.item.title.length > 40 ? this.item.title.substring(0, 40) + '...' : this.item.title) : 
              '';
      }
  },
  created() {
      this.item = this.getContentById(this.id);
      this.loadData();
  },
  watch: {
      getSelectedLanguage() {
          this.loadData();
      },
      '$route.params.id'() {
          this.loadData();
      }
  },
}
</script>

<style scoped>

.news-article-item {
  border-radius: 15px;
  /* background-color: #f3f6fc; */
  width: 100%;
  height: 100%;
  display: flex;
}

.news-article-item {
  flex-direction: row;
  align-items: center;
  /* padding: 15px; */
  gap: 20px;
}

/* .news-article-item .news-img {
  width: 200px;
  height: 150px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
} */

.news-article-item .news-text {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  height: auto;
  padding: 0;
}

.news-article-item .news-content {
  flex-grow: 1;
  /* max-width: 70%; */
}

.news-article-item .news-button-container {
  align-self: center;
  width: auto;
  text-align: center;
  margin-left: auto;
}

.news-img img {
  max-width: 200px;
  max-height: 100px;
  width: 200px;
  height: 100px;
  object-fit: cover;
  /* border-radius: 8px; */
}

/* Text styles */
.news-text h3 {
  color: var(--main-color);
  font-size: 24px;
  margin: 0;
  padding: 0;
  /* letter-spacing: -1px; */
}

.news-article-item .news-text h3 {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  font-size: 24px;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-tag {
  color: #757575;
  margin: 0;
  font-size: 12px;
  line-height: 16px;
}

.news-content-p {
  color: #757575;
  font-size: 18px;
  line-height: 20px;
  margin: 0;
  padding: 0;
}

/* Button styles */
.card-news-button {
  border: 1px var(--main-color) solid;
  background-color: transparent;
  border-radius: 0.5rem;
  color: var(--main-color);
  font-size: 18px;
  text-align: center;
  padding: 5px 15px;
  display: inline-block;
  text-decoration: none;
  transition: all 0.3s ease;
  white-space: nowrap;
  padding: 10px;
}

.news-article-item .card-news-button {
  width: auto;
  min-width: 80px;
}

.card-news-button:hover {
  background-color: var(--main-color);
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.news-title-link{
  color: var(--main-color);
  text-decoration: none;
}

@media only screen and (max-width: 768px) {
  .card-news-button {
    width: 100%;
    align-self: center;
    padding: 5px;

  }
  
  .news-article-item {
      flex-direction: column;
      padding: 10px;
      gap: 0;
  }
  
  .news-img {
      width: 100%;
      height: 200px;
      margin-bottom: 10px;
  }
  .news-img img{
    width: 100%;
    min-width: 100%;
    min-height: 200px;
    object-fit: cover;
    height: 200px;
  }
  
  .news-article-item .news-text {
      flex-direction: column;
      align-items: flex-start;
  }
  
  .news-article-item .news-content {
      max-width: 100%;
      /* margin-bottom: 15px; */
  }
  
  .news-article-item .news-button-container {
      align-self: flex-end;
      margin-top: 10px;
  }
}
</style>